import i18next from 'i18next';

// Each language is its own chunk, so a page downloads only the language it is in.
// The server-side render gets all of them up front from ./ssr.js.
const loaders = {
  en: () => Promise.all([
    import(/* webpackChunkName: "i18n-en" */ './locales/en/translations.json'),
    import(/* webpackChunkName: "i18n-en" */ './locales/en/terms.json'),
  ]).then(([translations, terms]) => ({ translations: translations.default, terms: terms.default })),
  es: () => import(/* webpackChunkName: "i18n-es" */ './locales/es/translations.json').then((m) => ({ translations: m.default })),
  de: () => import(/* webpackChunkName: "i18n-de" */ './locales/de/translations.json').then((m) => ({ translations: m.default })),
  fr: () => import(/* webpackChunkName: "i18n-fr" */ './locales/fr/translations.json').then((m) => ({ translations: m.default })),
};

i18next.init({
  fallbackLng: 'en',
  resources: {},
  partialBundledLanguages: true,
  ns: ['translations'],
  defaultNS: 'translations',
  returnObjects: true,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
      escapeValue: false, // not needed for react!!
  }
});



i18next.languages = ['es', 'en', 'de', 'fr'];

export const supportedLanguage = (lang) => (loaders[lang] ? lang : 'en');

export const addLanguageResources = (lang, namespaces) => {
  Object.entries(namespaces).forEach(([ns, resources]) => {
    i18next.addResourceBundle(lang, ns, resources, true, true);
  });
};

export const isLanguageLoaded = (lang) => {
  const target = supportedLanguage(lang);
  return [target, 'en'].every((l) => i18next.hasResourceBundle(l, 'translations'));
};

const pending = {};
const loadOne = (lang) => {
  if (i18next.hasResourceBundle(lang, 'translations')) return Promise.resolve();
  pending[lang] = pending[lang] || loaders[lang]().then((namespaces) => addLanguageResources(lang, namespaces));
  return pending[lang];
};

// English is always loaded as well: it is the fallback for keys a language doesn't have.
export const loadLanguage = (lang) => {
  const target = supportedLanguage(lang);
  return Promise.all(target === 'en' ? [loadOne('en')] : [loadOne(target), loadOne('en')]);
};

export default i18next;
